import React from "react";
import { LinearProgress, Fade } from "@mui/material";

const LinearProgressIndicator = ({ loader }) => {
    return (
        <Fade in={loader}>
            <LinearProgress
                sx={{
                    backgroundColor: "white",
                    "& .MuiLinearProgress-bar": {
                        backgroundColor: "#673ab7",
                    },
                }}
            />
        </Fade>
    );
};

export default LinearProgressIndicator;
